import translations from 'ckeditor5/translations/en.js';
import premiumFeaturesTranslations from 'ckeditor5-premium-features/translations/en.js'

translations.en.dictionary = {
    ...translations.en.dictionary,
    ...premiumFeaturesTranslations.en.dictionary,
    'Line Height': 'Line Height',
    'Styles': 'Styles',
    'Classes': 'Classes',
    'Image spacing': 'Spacing',
    'HSpace': 'Horizontal space',
    'VSpace': 'Vertical space',
};

translations.en.dictionary['Resize image (in %0)'] = 'Image width (in %0)';

export default translations;